@if (
  {
    row: columnData | async,
  };
  as $
) {
  <p>{{ $.row!.class_utilization }} %</p>
}
